import { CACHE_KEYS } from "@api/constants/cacheKeys";
import { handleGlobalGetRequestQuery } from "@api/functions/getRequests";
import { useState } from "react";
import { IGetServiceProps } from "@api/types/globalService.types";
import { useQuery } from "@tanstack/react-query";
import URLS from "@api/constants/urls";
import { urlUtility } from "@repo/utilities/url.utility.ts";
import useGlobalDebounceHandler from "./useGlobalDebounceHandler";

export function useActivityService({
  page = "1",
  per_page = "15",
  enableQuery,
}: IGetServiceProps) {
  // States
  const [searchQuery, setSearchQuery] = useState<string>("");

  const { debouncedQuery } = useGlobalDebounceHandler(searchQuery);
  const getAllActivityService = useQuery({
    queryKey: [...CACHE_KEYS.ACTIVITY, debouncedQuery, page, per_page],
    queryFn: () =>
      handleGlobalGetRequestQuery({
        url: URLS.ACTIVITIES,
        searchParams: {
          "filter[log_name]": debouncedQuery,
          page,
          per_page,
        },
      }),
    enabled: enableQuery,
  });

  return {
    states: { searchQuery, setSearchQuery },
    services: { getAllActivityService },
  };
}

export function useGetSingleActivity() {
  const urlQueries = urlUtility.getUrlQueries(location.search);
  const activity_id = urlQueries?.["activity-id"];
  const getSingleActivityService = useQuery({
    queryKey: [...CACHE_KEYS.ACTIVITY, activity_id],
    queryFn: () =>
      handleGlobalGetRequestQuery({
        url: `${URLS.ACTIVITIES}/${activity_id}`,
      }),
    enabled: activity_id ? true : false,
  });
  return {
    services: { getSingleActivityService },
  };
}
